import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/common/ErrorBoundary';

// Production ortamında logları sustur
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // console.warn ve console.error hata takibi için açık bırakılabilir 
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// 🚀 Unified Service Worker Kaydı (Cache + Push + Otomatik Güncelleme)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const apiKey = process.env.REACT_APP_FIREBASE_API_KEY || "";
    const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "";
    const messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "";
    const appId = process.env.REACT_APP_FIREBASE_APP_ID || "";
    const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "";
    const storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "";

    const swUrl = `/sw.js?apiKey=${encodeURIComponent(apiKey)}&projectId=${encodeURIComponent(projectId)}&messagingSenderId=${encodeURIComponent(messagingSenderId)}&appId=${encodeURIComponent(appId)}&authDomain=${encodeURIComponent(authDomain)}&storageBucket=${encodeURIComponent(storageBucket)}`;

    navigator.serviceWorker.register(swUrl)
      .then((registration) => {
        console.log('✅ Sectorpilot Unified SW registered:', registration);

        // 🔄 Yeni bir sürüm bulunduğunda dinle
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('✨ Sectorpilot: Yeni bir sürüm hazır!');
              window.dispatchEvent(new CustomEvent('pwa_update_available', { detail: { registration } }));
            }
          });
        });

        // 📱 Standalone PWA alta atılıp tekrar açıldığında (Resume / Ekran Kilidi Açılınca) otomatik güncelleme kontrolü
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible' && registration) {
            registration.update().catch((err) => {
              console.warn('PWA update check failed:', err);
            });
          }
        });
      })
      .catch((registrationError) => {
        console.warn('⚠️ Unified SW registration failed:', registrationError);
      });

    // 🔄 Controller değiştiğinde (yeni SW devreye girdiğinde) sayfayı taze kodla yenile
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
